import styled, {withTheme} from "styled-components"

export default withTheme(styled.header`
  height: ${props => props.theme.constants.headerHeight}px;
`)
